module.exports = __webpack_public_path__ + "img/sustainable_general_practice.12203792.png";